import { Button, Modal } from '@shared/ui/kit';
import { FC } from 'react';
import { createPortal } from 'react-dom';
import stylex from '@stylexjs/stylex';
import { styles } from './styles';
import { fonts } from '@shared/tokens/fonts.stylex';

interface FinancialWarningModalProps {
  open: boolean;
  onClose: () => void;
  onForceSend: () => void;
  ticketsCount: number;
  emailCount: number;
  smsCount: number;
  vkCount?: number;
}
export const FinancialWarningModal: FC<FinancialWarningModalProps> = ({
  open,
  onClose,
  onForceSend,
  ticketsCount,
  emailCount,
  smsCount,
  vkCount = 0,
}) => {
  if (!open) return null;
  return createPortal(
    <Modal
      active={open}
      settingsContainer={{ minHeight: '429px', minWidth: '480px', padding: '0px' }}
      settingsHeader={{ padding: '0px' }}
      settingsFooter={{ padding: '0px' }}
    >
      <div {...stylex.props(styles.modalContent)}>
        <div {...stylex.props(styles.heading)}>Отправить билеты</div>
        <div {...stylex.props(styles.infoContainer)}>
          <div {...stylex.props(styles.information)}>Вы собираетесь отправить {ticketsCount} билетов</div>
          <div {...stylex.props(styles.details)}>
            <div {...stylex.props(styles.detailsTitle)}>Будет отправлено:</div>
            <div {...stylex.props(styles.detailRowContainer)}>
              {vkCount > 0 && (
                <div {...stylex.props(styles.detailRow)}>
                  <div {...stylex.props(styles.detailLabel)}>VK Teams:</div>
                  <div {...stylex.props(styles.detailValue)}>{vkCount}</div>
                </div>
              )}
              {emailCount > 0 && (
                <div {...stylex.props(styles.detailRow)}>
                  <div {...stylex.props(styles.detailLabel)}>E-mail:</div>
                  <div {...stylex.props(styles.detailValue)}>{emailCount}</div>
                </div>
              )}
              {smsCount > 0 && (
                <div {...stylex.props(styles.detailRow)}>
                  <div {...stylex.props(styles.detailLabel)}>СМС:</div>
                  <div {...stylex.props(styles.detailValue)}>{smsCount}</div>
                  <div {...stylex.props(styles.detailCost)}>(~ {smsCount * 5} руб.)</div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div {...stylex.props(styles.actionContainer)}>
          <Button
            variant="secondary"
            settings={{ padding: '8px 20px', fontFamily: fonts.din2014Regular, width: '85px' }}
            size="small"
            onClick={onClose}
          >
            Отмена
          </Button>
          <Button
            variant="accent"
            settings={{ padding: '8px 20px', fontFamily: fonts.din2014Regular, width: '118px' }}
            size="small"
            onClick={onForceSend}
          >
            Отправить
          </Button>
        </div>
      </div>
    </Modal>,
    document.getElementById('modal') as Element
  );
};
